// ════════════════════════════════════════════════════════════════════
// chart.js — bucket already-calc'd rows into day/month chart buckets.
// ════════════════════════════════════════════════════════════════════
export function bucketRowsForChart(rows) {
  const safe = (rows || []).filter(r => r?.dateObj instanceof Date && !isNaN(r.dateObj));
  if (safe.length === 0) return { data: [], mode: "day" };
  const times = safe.map(r => r.dateObj.getTime());
  const spanDays = (Math.max(...times) - Math.min(...times)) / 86400000;
  const mode = spanDays <= 32 ? "day" : "month";
  const MON = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
  const map = new Map();
  for (const r of safe) {
    const d = r.dateObj;
    const key = mode === "day"
      ? `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`
      : `${d.getFullYear()}-${d.getMonth()}`;
    if (!map.has(key)) {
      map.set(key, {
        sort: mode === "day" ? new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()
                             : new Date(d.getFullYear(), d.getMonth(), 1).getTime(),
        shortLabel: mode === "day" ? `${d.getDate()} ${MON[d.getMonth()]}`
                                   : `${MON[d.getMonth()]} '${String(d.getFullYear()).slice(2)}`,
        label: mode === "day" ? `${d.getDate()} ${MON[d.getMonth()]} ${d.getFullYear()}`
                              : `${MON[d.getMonth()]} ${d.getFullYear()}`,
        trueProfit: 0, gross: 0, netReceivable: 0, vat: 0,
      });
    }
    const b = map.get(key);
    b.trueProfit    += (r.trueProfit || 0);
    b.gross         += (r.gross || 0);
    b.netReceivable += (r.netReceivable || 0);
    b.vat           += (r.vat || 0);
  }
  const data = Array.from(map.values())
    .sort((a, b) => a.sort - b.sort)
    .map(b => ({ ...b, trueProfit: +b.trueProfit.toFixed(2), gross: +b.gross.toFixed(2), netReceivable: +b.netReceivable.toFixed(2), vat: +b.vat.toFixed(2) }));
  return { data, mode };
}
